const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20natural%20makeup%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20editorial%20quality&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '这个瓜我吃定了！每天打开每日爆料就像开盲盒，永远不知道今天又有谁塌房，编辑部速度是真的快。',
    likes: 2389,
    tag: '热门话题',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20a%20young%20Chinese%20man%20with%20modern%20hairstyle%2C%20natural%20light%2C%20white%20background%2C%20editorial%20quality%20headshot&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    name: '娱乐圈纪检委',
    time: '18分钟前',
    content: '说实话现在娱乐圈太乱了，还好有每日爆料这种平台帮我们监督。希望能一直保持这种更新速度！',
    likes: 1567,
    tag: '铁粉认证',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20a%20young%20Chinese%20woman%20smiling%2C%20warm%20tone%2C%20simple%20background%2C%20editorial%20style%20headshot%20photography&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    name: '八卦小能手',
    time: '42分钟前',
    content: '从他们刚上线就开始关注了，信息更新真的很快，而且每条爆料都有据可查，不像某些营销号瞎编乱造。',
    likes: 3201,
    tag: '老用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">网友热评</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">吃瓜群众的声音，才是最真实的反馈</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-background-300 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</span>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 whitespace-nowrap shrink-0">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}